module.exports = __webpack_public_path__ + "static/from-counterculture-to-cyberculture-bff671f1f36e341a9896e7a5c4ee9477.jpg";